import { Attributes, Misc, Rules, Validation, ValueObject } from '@singularsystems/neo-core';

export default class DividendSummaryCriteria extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    public entityId: number | null = null;

    @Attributes.Nullable()
    public issuerInvestmentId: number | null = null;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date | null = null;
    
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = null;

    // Client only properties / methods

    public issuerInvestmentName: string = "";

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Dividend Summary Criteria";
    }
}